import { useAppStore } from "../../store";
import { HomeOutlined, LeftOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
var NotFoundPage = function NotFoundPage() {
  var homePath = useAppStore(function (s) {
    return s.homePath;
  });
  var _useAppStore = useAppStore(function (s) {
      return s.pageHandlers;
    }),
    remove = _useAppStore.remove;
  var locale = useAppStore(function (s) {
    return s.locale;
  });
  var navigate = useNavigate();
  var isMicroApp = window.__MICRO_APP_ENVIRONMENT__;
  return /*#__PURE__*/_jsx(Result, {
    status: "404",
    title: "404",
    subTitle: "Sorry, the page you visited does not exist.",
    extra: [/*#__PURE__*/_jsx(Button, {
      type: "primary",
      icon: /*#__PURE__*/_jsx(LeftOutlined, {}),
      onClick: function onClick() {
        remove();
      },
      children: locale === null || locale === void 0 ? void 0 : locale.back
    }, "back"), isMicroApp ? null : /*#__PURE__*/_jsx(Button, {
      type: "default",
      icon: /*#__PURE__*/_jsx(HomeOutlined, {}),
      onClick: function onClick() {
        remove();
        navigate(homePath, {
          replace: true
        });
      },
      children: locale === null || locale === void 0 ? void 0 : locale.home
    }, "home")]
  });
};
export default NotFoundPage;